import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { ShareRequestInput } from 'sr-types/lib/account/v1/graphql';
import { client as accountClient } from '../../common/auth/account';
import { FETCH_POLICY_CONFIG, FILTER_IDENTIFIERS } from '../constants/constants';
import { ENTITY_CONSTANTS } from '../constants/entityConstants';
import { searchClient, slimResultsQuery } from '../list/slimQuery';
import type { Filter } from '../types/savedFilters';

const savePreference: DocumentNode = gql`
    mutation SavePreference($preference: PreferenceInput!, $shareInput: ShareRequestInput) {
        savePreference(preference: $preference, shareInput: $shareInput) {
            id
            reference {
                id
            }
            errors {
                field
                key
                message
            }
        }
    }
`;

const deletePreference: DocumentNode = gql`
    mutation DeletePreference($id: ID!) {
        deletePreference(id: $id) {
            id
            errors {
                field
                key
                message
            }
        }
    }
`;

export const loadPreferencesQuery = (ownerId: string, additionalFilters?: Filter[], pageSize: number = 500) => {
    return searchClient.query({
        query: slimResultsQuery(ENTITY_CONSTANTS.preference, true),
        context: {
            headers: {
                ownerId
            }
        },
        variables: {
            filters: [
                { identifier: FILTER_IDENTIFIERS.entity, value: ENTITY_CONSTANTS.preference },
                ...(additionalFilters || [])
            ],
            page: { from: 0, size: pageSize },
            tokenize: true
        },
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
    });
};

export const savePreferenceMutation = (
    accountId: string,
    preferencePayload: Record<string, any>,
    shareInput?: ShareRequestInput
) => {
    return accountClient
        .mutate({
            mutation: savePreference,
            context: {
                headers: {
                    ownerId: accountId
                }
            },
            variables: {
                preference: preferencePayload,
                shareInput: shareInput || null
            }
        })
        .catch((err) => {
            console.warn('Save preferences failed:', err);
            throw err;
        });
};

export const deletePreferenceMutation = (accountId: string, preferenceId: string) => {
    return accountClient.mutate({
        mutation: deletePreference,
        context: {
            headers: {
                ownerId: accountId
            }
        },
        variables: {
            id: preferenceId
        }
    });
};
